import Vue from 'vue'
import debug from '../components/debug.vue'

Vue.component('debug', debug)
